import { useCostLinesStore } from "entities/CostLines";
import { constants } from "entities/RequestBasicDetails";
import { useRequestStore } from "entities/Request";
import { useEffect } from "react";
import { Row } from "react-bootstrap";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Form } from "shared/ui";

const { accomodationOptionsEnum } = constants.basicDetails;

function SelectAccomodation({ register, control, error, disabled }) {
  const { t } = useTranslation("RequestBasicDetails");
  const request = useRequestStore((state) => state.request);
  const costLines = useCostLinesStore((state) => state.costLines);
  const addCostLine = useCostLinesStore((state) => state.addCostLine);
  const deleteCostLine = useCostLinesStore((state) => state.deleteCostLine);
  const accommodationPaymentType = useWatch({
    name: "accommodation_payment_type",
    control,
  });
  useEffect(() => {
    if (accommodationPaymentType) {
      const accomodationRequiredLine = costLines.find(
        (costLine) => costLine.accommodation_required_line
      );
      if (
        accommodationPaymentType === accomodationOptionsEnum.User &&
        request.is_accommodation_editable &&
        !accomodationRequiredLine
      ) {
        addCostLine({ accommodation_required_line: true });
      } else if (
        accommodationPaymentType === accomodationOptionsEnum.BookingTool &&
        accomodationRequiredLine
      ) {
        deleteCostLine(accomodationRequiredLine.id);
      }
    }
  }, [accommodationPaymentType, request, costLines]);

  return (
    <Row as="fieldset" disabled={disabled}>
      <hr className="my-5 text-muted" />
      <div className="fw-bolder mb-3">
        {disabled ? t("accomodation") : t("select_accomodation")}
      </div>
      <Form.Check
        type="radio"
        name="accommodation_payment_type"
        value={accomodationOptionsEnum.User}
        error={error}
        register={register}
        label={t("labels.accomodation_private_payment")}
        id="radio-1"
      />
      <Form.Check
        type="radio"
        name="accommodation_payment_type"
        value={accomodationOptionsEnum.BookingTool}
        error={error}
        register={register}
        label={t("labels.accomodation_booking_tool_payment")}
        id="radio-2"
      />
    </Row>
  );
}

export default SelectAccomodation;
